/**
 * 游戏平衡常量 — v2 三幕式结构
 */

// ============================================
// 第一幕：亲友初筛
// ============================================
export const ACT1_MAX_ROUNDS = 8;
export const ACT1_HAND_SIZE = 4;
export const ACT1_DECK_SIZE = 15;
export const ACT1_REFILL_INTERVAL = 2;
export const ACT1_REFILL_COUNT = 3;

/** 亲友态度阈值 */
export const FAMILY_ATTITUDE_PASS = 20;       // 顺利通关
export const FAMILY_ATTITUDE_BARELY = 0;      // 勉强通关
export const FAMILY_ATTITUDE_FAIL = -40;      // 提前结束

/** 亲友态度初始值 */
export const FAMILY_ATTITUDE_INITIAL = 0;

/** 勉强通关惩罚 */
export const BARELY_PASS_COMFORT_PENALTY = 10;
export const BARELY_PASS_CARD_REDUCTION = 0.5;

/** 地下情模式修正 */
export const UNDERGROUND_AFFECTION_BONUS = 1.2;
export const UNDERGROUND_COMFORT_PENALTY = 20;

// ============================================
// 第二幕：二人世界
// ============================================
export const ACT2_MAX_ROUNDS = 15;
export const ACT2_HAND_SIZE = 5;
export const ACT2_CARD_GEN_INTERVAL = 3;
export const ACT2_CARDS_PER_BATCH = 6;
export const ACT2_MAX_SWAPS = 3;
export const ACT2_EXCHANGES_PER_ROUND = 3;

/** 第二幕初始指标 */
export const INITIAL_AFFECTION = 50;
export const INITIAL_COMFORT = 50;
export const INITIAL_ENERGY = 100;
export const INITIAL_COMMITMENT = 30;

/** 第二幕提前结束阈值 */
export const ACT2_AFFECTION_FAIL = 15;
export const ACT2_COMFORT_FAIL = 20;

/** 第二幕结局判定阈值 */
export const ACT2_HOT_AFFECTION = 75;
export const ACT2_HOT_COMFORT = 65;
export const ACT2_HOT_COMPAT = 70;
export const ACT2_AMBIGUOUS_AFFECTION = 50;
export const ACT2_AMBIGUOUS_COMFORT = 50;
export const ACT2_COLD_AFFECTION_MIN = 40;
export const ACT2_COLD_COMFORT_MIN = 40;
export const ACT2_ASSIST_HIGH = 55;
export const ACT2_ASSIST_LOW_MIN = 35;
export const ACT2_FRIEND_AFFECTION_MAX = 50;
export const ACT2_FRIEND_COMFORT_MIN = 55;
export const ACT2_FAIL_THRESHOLD = 25;

// ============================================
// 第三幕：关系考验
// ============================================
export const ACT3_MAX_WEEKS = 8;
export const ACT3_TRIAL_COUNT = 2;
export const ACT3_HIDDEN_TRIAL = 1;
export const INITIAL_STABILITY = 50;
export const ENERGY_MAX = 100;
export const ENERGY_RECOVERY_WEEKLY = 10;

/** 第三幕提前结束阈值 */
export const ACT3_COMMITMENT_WIN = 75;
export const ACT3_COMMITMENT_FAIL = 10;
export const ACT3_ENERGY_FAIL = 10;
export const ACT3_STABILITY_FAIL = 20;

/** 第三幕结局判定阈值 */
export const ACT3_PERFECT_COMMITMENT = 70;
export const ACT3_PERFECT_STABILITY = 60;
export const ACT3_GOOD_COMMITMENT_MIN = 55;
export const ACT3_GOOD_STABILITY_MIN = 50;
export const ACT3_RATIONAL_COMMITMENT = 40;
export const ACT3_FEAR_COMMITMENT = 50;
export const ACT3_FEAR_STABILITY = 40;

/** 第二幕结局对第三幕的加成 */
export const HOT_ENTRY_COMMITMENT_BONUS = 15;
export const HOT_ENTRY_STABILITY_PENALTY = 10;
export const COLD_ENTRY_COMMITMENT_PENALTY = 10;
export const COLD_ENTRY_STABILITY_BONUS = 10;

// ============================================
// v1 兼容导出（供旧代码使用，v2完成后删除）
// ============================================
/** @deprecated use ACT2_MAX_ROUNDS */
export const MAX_TURNS = ACT2_MAX_ROUNDS;
/** @deprecated use INITIAL_AFFECTION */
export const INITIAL_CP = INITIAL_AFFECTION;
/** @deprecated */
export const CP_WIN_THRESHOLD = 95;
/** @deprecated */
export const CP_LOSE_THRESHOLD = 5;
/** @deprecated */
export const CP_ZUOZUO_THRESHOLD = 15;
/** @deprecated use ACT2_CARD_GEN_INTERVAL */
export const DRAFT_INTERVAL = ACT2_CARD_GEN_INTERVAL;
/** @deprecated use ACT2_EXCHANGES_PER_ROUND */
export const EXCHANGES_PER_ROUND = ACT2_EXCHANGES_PER_ROUND;
/** @deprecated use ACT2_MAX_SWAPS */
export const MAX_SWAPS = ACT2_MAX_SWAPS;
/** @deprecated use ACT2_HAND_SIZE */
export const MAX_HAND_SIZE = ACT2_HAND_SIZE;
/** @deprecated */
export const AUTO_GEN_CARD_COUNT = 9;
